export enum ApiKeys {
  DashboardExperience = 'activate/dashboard/v1',
}
